import { useRef, useEffect, useState, useCallback } from "react"
import Layout from '../../Layout'
import AlertList from "components/Cart/AlertList"
import CartAction, { ProductFull } from "components/Cart/CartAction"
import CartSummarySidebar from "components/Cart/CartSummarySidebar"
import YouMightLike from "components/Cart/YouMightLike"
import { listCartItems, CartItems } from "../../api/Cart"

export default function Cart() {
    const [cartItems, setCartItems] = useState<CartItems[]>([]);
    const [summaryData, setSummaryData] = useState({ totalQuantity: 0, totalPrice: 0 });
    const [selectedItems, setSelectedItems] = useState<ProductFull[]>([]);

    const fetchCartData = async () => {
        try {
            const data = await listCartItems();
            setCartItems(data.items || []);
        } catch (error) {
            console.error("Failed to fetch cart data", error);
        }
    }

    const handleSelectionChange = useCallback((totalQuantity: number, totalPrice: number, items: ProductFull[]) => {
        setSummaryData({ totalQuantity, totalPrice });
        setSelectedItems(items);
    }, []);

    useEffect(() => {
        document.body.classList.add("NoneFooter");
        fetchCartData();

        return () => {
            document.body.classList.remove("NoneFooter");
        };
    }, []);

    return (
        <Layout>
            <div className="MuiContainer-root styles_container__eEOzu MuiContainer-disableGutters MuiContainer-maxWidthLg mb-[32px] mobile-pb-230">
                <div className="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-3">
                    <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-sm-12 MuiGrid-grid-md-9 w-full-1199 px-1199-20-140">
                        <div className="styles_containerBreadcrumbs__K4TEO hidden-1199">
                            <nav className="MuiTypography-root MuiBreadcrumbs-root MuiTypography-body1 MuiTypography-colorTextSecondary" aria-label="breadcrumb">
                                <ol className="MuiBreadcrumbs-ol">
                                    <li className="MuiBreadcrumbs-li">
                                        <a className="styles_item_breadcrumb__eYGFd" href="/">Trang chủ</a>
                                    </li>
                                    <li aria-hidden="true" className="MuiBreadcrumbs-separator" ins-init-condition="#Lk11aUJyZWFkY3J1bWJzLW9sIGxpOm5vdCg6Zmlyc3Qp">
                                        <svg className="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall" focusable="false" viewBox="0 0 24 24" aria-hidden="true">
                                            <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path>
                                        </svg>
                                    </li>
                                    <li className="MuiBreadcrumbs-li" ins-init-condition="#Lk11aUJyZWFkY3J1bWJzLW9sIGxpOm5vdCg6Zmlyc3Qp">
                                        <span className="styles_item_breadcrumb__eYGFd styles_last_breadcrumb__c7IQm">Giỏ Hàng</span>
                                    </li>
                                </ol>
                            </nav>
                        </div>
                        <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-md-12">
                            <div className="styles_attentionList__cHet8">
                               


                                <CartAction 
                                    cartItems={cartItems} 
                                    onCartChange={fetchCartData} 
                                    onSelectionChange={handleSelectionChange}
                                />

                                {/* <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-md-12">
                                    <div className="styles_notes__Li8i1">
                                        <div className="styles_note_content__qKelT">Trong trường hợp không tìm được thuốc mong muốn, quý khách vui lòng điền yêu cầu vào khung bên dưới. Chúng tôi sẽ liên hệ mua thuốc và báo giá sớm nhất có thể.</div>
                                        <textarea rows={1} name="note" className="styles_text_area__ay6bm" aria-label="Ghi chú của khách hàng" placeholder="Nhập ghi chú..." style={{ height: "64px", overflow: "hidden" }}></textarea>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                    <CartSummarySidebar 
                        totalQuantity={summaryData.totalQuantity} 
                        totalPrice={summaryData.totalPrice} 
                        onCartChange={fetchCartData}
                        selectedItems={selectedItems}
                    />
                </div>
                <YouMightLike />
            </div>
        </Layout>
    )
}
